<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="签署合同"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"   label-width="100px">
       
        <el-form-item label="职位信息" style="color:#4C71DB">   
          {{info.title}}
        </el-form-item>

        <el-form-item label="入职时间">  
          {{info.check_time}}
        </el-form-item>

        <el-form-item label="联系方式">
          {{info.check_mobile}}
        </el-form-item>

        <el-form-item label="入职地址" >
          {{info.address}}
        </el-form-item>

        <el-form-item label="入职通知">
          {{info.check_mark}}
        </el-form-item>

        <el-form-item label="合同类型">
          {{info.contract_type==1?"平台合同":"上传合同"}}
        </el-form-item>

        <el-form-item label="" >
          <el-row v-if="info.contract_type==1">
            <div class="file-cont">
                <div>
                  <img src="@/assets/chat-img/chat-contract.png"></img>
                  <b>平台合同</b>
                </div>
                <el-link type="primary">点击查看</el-link>
            </div>
          </el-row>
          <el-row v-if="info.contract_type==2">
            <div class="file-cont2" v-if="info.contract_file">
                <div>
                  <img src="@/assets/chat-img/chat-contract.png"></img>
                  <b>{{info.contract_fname}}</b>
                </div>
                <el-link type="primary">点击查看</el-link>

            </div>
          </el-row>
        </el-form-item>

        <!--状态13拒绝14同意-->
        <el-form-item label="签署状态" v-if="info.handle==2" >
          {{info.contract_status==3?'拒签':'签署'}}
          <!--//3是拒签，1是签署，2待签署-->
        </el-form-item>

        <el-form-item label="拒绝原因" v-if="info.handle==2&&info.contract_status==3" >
          {{info.contract_reason}}
        </el-form-item>

        <el-form-item label="参加面试" v-if="info.handle==1&&isSend==2" >
          <el-radio-group v-model="formData.relation_status" size="small">
            <el-radio label="13" border>拒绝</el-radio>
            <el-radio label="14" border>同意</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="拒绝理由" v-if="info.handle==1&&formData.relation_status==13">
          <el-input 
            type="textarea" 
            v-model="formData.contract_reason"  
            :rows="4"
            placeholder="输入拒绝原因"></el-input>
        </el-form-item>

      </el-form>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" v-if="info.handle==1&&isSend==2" >确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { auditInfo,auditUpdate,addressInfo,addressUpdate,contractInfo,contractUpdate} from "@/api/chat/index";

export default {
  components: { },
  inject:['sendHandleMsg'],

  data() {
    return {
      visible: false,
      isSend:1,
      info:{
        title: "",
        job_id: "",
        handle:"",
        contract_status: "",
        check_time: "",
        check_mobile: "",
        check_mark: "",
        address: "",
        lat: "",
        lng: "",
        enroll_id: "",
        contract_type: "",
        contract_fname: "",
        contract_file: "",
        relation_status:"",//状态13拒绝14同意
        contract_reason: "",
      },

      formData: {
        enroll_id:"",
        relation_status:"14",//状态13拒绝14同意
        contract_reason: "",
       
       
      }
    };
  },

 
mounted() {

},
destroyed(){


},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();

      this.visible = false;

    },


    init(isSend,enroll_id) {
      this.visible = true;
      this.isSend=isSend;
      this.formData.enroll_id=enroll_id;
      
      this.initInfo();
    },

    initInfo(){
      var that = this;
      contractInfo({"enroll_id":that.formData.enroll_id}).then((response) => {
        if(response.code==200){
          that.info = response.data;

        }else{
          that.$message.warning(response.msg?response.msg:"获取信息失败");
        }
      });
    },

    
    submit(){
      var that=this;
      if(this.formData.relation_status==5){
        if(this.formData.reason==""){
          that.$message.warning("请输入拒绝理由");
          return;
        }

      }
      
      this.$refs["form"].validate((valid) => {
          if (valid) {
            contractUpdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
               // var enroll_id=response.enroll_id;
               // that.$emit('callback',enroll_id);

                that.visible = false;
                that.sendHandleMsg(that.formData.relation_status==14?24:25,'',that.formData.enroll_id,'','','','','');


              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .file-cont{
    display: flex;
    justify-content: space-between;
    border: 1px solid #CCCCCC;    
    border-radius: 3px;
    padding: 10px;

    div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-self: center;
      img{
        width: 30px;
      }
      b{
        color: #333333;

      }
    }
  
  }


  .file-cont2{
    display: flex;
    justify-content: space-between;
    border: 1px solid #CCCCCC;    
    border-radius: 3px;
    margin-top: 20px;
    padding: 10px;
    position: relative;

    .close{
      position: absolute;
      right: -7px;
      top: -7px;
      width: 15px;
    }

    div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-self: center;
      img{
        width: 30px;
      }
      b{
        color: #333333;

      }
    }
  
  }

  .upload{
    text-align: center;
    border: 1px solid #4C71DB;
    padding: 20px;
    margin-top:20px;
    border-radius: 3px;

  }
</style>
